export default __webpack_public_path__ + "static/media/upee-min.2a51685f.png";